<div *ngIf="loading" class="dashboard-tabs">

    <div class="dashboard-disclaimer-banner" *ngIf="dashboardConfig === 'insights' && disclaimerMessage != null && disclaimerMessage.length != 0">
        <div class="exclamation-mark-manual"><i class="fa fa-exclamation-circle"></i></div>
        <div class="message-title defaultCursor Spacebox__flat-l Auto_Title_Message">Disclaimer</div>
        <div class="message defaultCursor Spacebox__flat-l Auto_Title_Message" >{{disclaimerMessage}}</div>
    </div>


    <dls-tabs>
        <a *ngFor="let tabs of workListTabDetails" (click)="onTabChange(tabs.name)"
            class="{{cssClassFormat(tabs.name)}}"   
            [ngClass]="{'pt-selected':tabs.name === currentTab.name}">
            <span>{{tabs.name}}</span>
        </a>
    </dls-tabs>

   <div *ngIf="!currentTab.hasOwnProperty('componentToLoad')" class = "tabs-content">
        <gen-dashboard class="{{workList?.name}}" *ngIf="workListTabDetails?.length>0"
            [worklistConfig]="workList"
            [ngClass]="{'dashboard-with-tabs': !!workListTabDetails?.length}"
        ></gen-dashboard>
    </div>    

   <div *ngIf="currentTab.hasOwnProperty('componentToLoad')">
        <gen-dynamic-form class="info-dynamic-form" [formName]="currentTab.additionalPayload.formId"        
        ></gen-dynamic-form>
    </div> 
</div>
